export const getPDF = (scenarios) => {
    const now = new Date();
    const width = 595;
    const height = 842;
    const margin = 44;
    // @ts-ignore
    const doc = new PDFDocument({
        size: [width, height],
        margins: {
            top: 40,
            left: margin,
            right: margin,
            bottom: margin
        }
    });
    const stream = doc.pipe(blobStream());
    const getMonthName = (num) => {
        switch (num) {
            case 0:
                return "JAN";
            case 1:
                return "FEB";
            case 2:
                return "MAR";
            case 3:
                return "APR";
            case 4:
                return "MAY";
            case 5:
                return "JUN";
            case 6:
                return "JUL";
            case 7:
                return "AUG";
            case 8:
                return "SEP";
            case 9:
                return "OCT";
            case 10:
                return "NOV";
            case 11:
                return "DEC";
            default:
                return "";
        }
    };
    const darkTeal = "#0084A0";
    const cyan = "#05a3d3";
    doc.save();
    doc.lineWidth(1);
    doc.moveTo(margin, 108);
    doc.lineTo(width - margin, 108).stroke(darkTeal);
    doc.moveTo(margin, 690);
    doc.lineTo(width - margin, 690).stroke(darkTeal);
    doc.restore();
    doc.save();
    doc.translate(30, -10);
    doc.scale(1.25);
    doc.save();
    const grad = doc.linearGradient(0, 0, 52, 52);
    grad.stop(0, "#00adc3");
    grad.stop(1, "#0085a1");
    doc.translate(-202, -73);
    doc.path("M251.5 143.3a21.4 21.4 0 1 0-5.5 5.7l9.4 3.8z").fill(grad);
    doc.restore();
    doc.fillColor("#ffffff");
    doc
        .path("M19.1 51.7v7.4a1.2 1.2 0 0 0 .8 0c1.5-.3 1.9-3.5 1.4-6-.4-1.7-1.3-2.3-2.4-2a3 3 0 0 0-2.8 3.9 " +
        "1.7 1.7 0 0 0 .4.8c-.9.1-1.5 0-1.6-1-.4-1.6 1.4-3.6 4-4.1a3.3 3.3 0 0 1 4.2 2.8c.5 2.9-.5 6.3-2.4 6.7a2.3 " +
        "2.3 0 0 1-1.7-.4v.5l-1.8.4.1-8.2 1.8-.6M29.4 48.9a1 1 0 0 1 1.3.8 1 1 0 0 1-.9 1.2 1 1 0 0 1-1.2-.8 " +
        "1 1 0 0 1 .8-1.2zm1.1 2.5v4.5a1 1 0 0 0 0 .4c0 .4.3.4.6.4a1.4 1.4 0 0 0 1-1.4h.5c-.3 2.2-1.5 2.7-2.2 " +
        "2.9a1.4 1.4 0 0 1-1.7-1.3 4.5 4.5 0 0 1 0-.8v-4.2z")
        .fill();
    doc
        .path("M34.7 51.9c-.5 0-.7.7-.8 1.3v4.3l-1.8.3v-6.5l1.8-.4v.7a1.9 1.9 0 0 1 1.3-1 1.3 1.3 0 0 1 1.7 1.1 " +
        "18.7 18.7 0 0 1 0 3.4.5.5 0 0 0 .6.4c.6 0 .7-.6.9-1.3l.5-.1c-.3 2.2-1.2 2.7-1.9 2.8a1.4 1.4 0 0 1-1.7" +
        "-1.1 21.2 21.2 0 0 1 0-3.4.5.5 0 0 0-.6-.5")
        .fill();
    doc
        .path("M43.6 48.9l-2.1 2.2h.4a1.4 1.4 0 0 1 1.6 1.2 1.5 1.5 0 0 1 0 .5v.6a1.3 1.3 0 0 0 0 .5c0 .2.2.4" +
        ".6.3a.8.8 0 0 0 .4-.1 1.5 1.5 0 0 1-.9 1.5 1.4 1.4 0 0 1-1.8-1.1 2.8 2.8 0 0 1 0-.7v-.5a2.8 2.8 0 0 0 0-" +
        ".5.5.5 0 0 0-.6-.5 1.5 1.5 0 0 0-.8.7v3.1l-1.9.4.2-9 1.7-.4v4.6l2-2.5 1.3-.2M26 66.2a4 4 0 0 1-3.2 3c-1." +
        "8.4-2.9-.2-3.3-2.4-.4-2.2-.2-6.8 3-7.5 1.3-.2 2.3 0 2.6 1.3 0 .7 0 1.2-.7 1.3a.9.9 0 0 1-.7-.1 1.6 1.6 0" +
        " 0 0 .3-1.3.7.7 0 0 0-1-.6c-1.3.3-2 3.8-1.4 6.4.2 1.1.7 1.9 1.9 1.6a3 3 0 0 0 2.2-1.7h.3")
        .fill();
    doc
        .path("M29.2 64.1c-.3 0-.4-.2-.5-.5a.7.7 0 0 1 .3-.7c0-.6-.3-.7-.6-.7-1 .2-1.2 2.5-1 3.9.2.8.4 1 .8.9.4" +
        "-.1 1-1.4 1-3m1-.8a4 4 0 0 0 1.7-1.2l.2.4a4.2 4.2 0 0 1-2 1.4c.2 2.4-.7 4.1-2.3 4.4a1.8 1.8 0 0 1-2.5-1.6c-" +
        ".3-1.4 0-4.6 2.5-5 1.1-.2 1.8.4 2 1.7")
        .fill();
    doc
        .path("M32.8 65c.2 1 .6 1 .9.9a1.3 1.3 0 0 0 .8-1.3v-3a.5.5 0 0 0-.6-.3c-1 .2-1.3 2.6-1 3.7zm3.6-5v4.5a" +
        "2.2 2.2 0 0 0 0 .4.5.5 0 0 0 .6.4c.5 0 .7-.7.8-1.3h.5c-.3 2.2-1.4 2.7-2 2.8a1.2 1.2 0 0 1-1.5-1 2.3 2.3 0" +
        " 0 1-1.7 1.6c-.8.2-1.8-.2-2-1.7-.2-1.5.1-4.6 2.3-5 .7-.1 1 0 1.2.5v-.6z")
        .fill();
    doc
        .path("M40.8 60.2c0-.4-.2-.5-.4-.5-.8.2-1.2 2.5-.9 4 .2.9.5 1 1.1.9a3 3 0 0 0 2-1.7h.5a4.3 4.3 0 0 1-3 3 " +
        "1.8 1.8 0 0 1-2.4-1.6c-.3-1.5 0-4.7 2.5-5 1.1-.3 1.5.3 1.6.9.1.6-.1.9-.5 1a1 1 0 0 1-.4 0 2 2 0 0 0 0-.8")
        .fill();
    doc
        .path("M45.3 59.4c-.4 0-.7.5-.8 1.1v4.4l-1.8.4.1-9 1.9-.6V59a2 2 0 0 1 1.3-1 1.3 1.3 0 0 1 1.7 1.2 18" +
        ".7 18.7 0 0 1 0 3.4c0 .7.2.5.6.4a.7.7 0 0 0 .4-.2 1.4 1.4 0 0 1-1.1 1.6c-1 .2-1.4-.4-1.6-1.2a24.3 24.3 0" +
        " 0 1 0-3.3c0-.8-.2-.6-.6-.5")
        .fill();
    doc
        .path("M25.9 52.4v.8a2.3 2.3 0 0 1 1.3-1 .9.9 0 0 1 1 .7 1 1 0 0 1-.6 1c-.7.2-.5-.7-1-.6a1.3 1.3 0 0 0-.8" +
        ".6v5l-1.8.4v-6.5l1.8-.4")
        .fill();
    doc.restore();
    doc.save();
    doc.translate(118, 35);
    doc.scale(0.48, 0.48);
    doc.fillColor("#96cdda");
    doc.save();
    doc
        .circle(59.5, 60.5, 58.5)
        .lineWidth(2)
        .dash(4, null)
        .stroke("#0484a0");
    doc.restore();
    doc.scale(0.62, 0.62);
    doc.translate(53, 28);
    doc.path("M8.1 33.8h72.2v86.4H8.1z").fill("#96cdda");
    doc
        .path("M71.8 25.5h8.7a6.9 6.9 0 0 1 6.9 6.9V121a6.9 6.9 0 0 1-6.9 6.8H8A6.9 6.9 0 0 1 1 " +
        "121V32.4a6.9 6.9 0 0 1 6.9-6.9h8.8")
        .miterLimit(10)
        .lineWidth(3)
        .stroke("#0484a0");
    doc
        .path("M69.2 36.8h-50a2.3 2.3 0 0 1-2.4-2.3V20.9a2.4 2.4 0 0 1 .7-1.7 2.3 2.3 0 0 1 1.7-.7h9v-2.3A15.7 " +
        "15.7 0 0 1 44.2.5a15.7 15.7 0 0 1 16 16v2.3h9a2.3 2.3 0 0 1 2.3 2.3v13.6a2.4 2.4 0 0 1-.6 1.7 4.6 4.6 0" +
        " 0 1-1.7.4z")
        .miterLimit(10)
        .fillAndStroke("#fabc16", "#0484a0");
    doc.circle(44.2, 16.4, 4.5).fillAndStroke("#fff", "#048480");
    doc
        .path("M25.3 113.1a5.6 5.6 0 1 1 5.6-5.6 5.7 5.7 0 0 1-5.7 5.6zm0-9.6a4 4 0 1 0 4 4 4.1 4.1 0 0 0-4-4z")
        .fill("#fff");
    doc
        .path("M60.6 57.5a5.6 5.6 0 1 1 5.6-5.6 5.6 5.6 0 0 1-5.6 5.6zm0-9.6a4 4 0 1 0 4 4 4 4 0 0 0-4-4z")
        .fill("#fff");
    doc
        .path("M25.3 103.5a1 1 0 0 1-1-.9v-8a15 15 0 0 1 15-15H43a.9.9 0 0 1 0 1.7h-3.8A13.2 13.2 0 0 0 26 94.5v8." +
        "1a.8.8 0 0 1-.7.9z")
        .fill("#fff");
    doc
        .path("M46.5 81.3H43a.9.9 0 1 1 0-1.7h3.6a13.2 13.2 0 0 0 13.2-13.2v-9.8a.9.9 0 1 1 1.8 0v9.8a14.9 14.9 0 " +
        "0 1-15 15z")
        .fill("#fff");
    doc
        .path("M47.2 99.6a1.6 1.6 0 0 1-.7-.2L38 90.8a.9.9 0 0 1 1.2-1.3l8.6 8.7a.9.9 0 0 1 0 1.2c0 .2-.3.2-.5.2z")
        .fill("#b92339");
    doc
        .path("M38.5 99.6a1.6 1.6 0 0 1-.6-.2.9.9 0 0 1 0-1.2l8.6-8.7a.9.9 0 0 1 1.2 1.3l-8.5 8.6a.8.8 0 0 1-.7.2z")
        .fill("#b92339");
    doc
        .path("M61.8 91.9a1 1 0 0 1-.9-1V78.8a.9.9 0 1 1 1.8 0V91a.9.9 0 0 1-1 .9z")
        .fill("#0484a0");
    doc
        .path("M68 85.7H55.7a.9.9 0 0 1 0-1.8H68a1 1 0 0 1 .9.9.9.9 0 0 1-1 .9z")
        .fill("#0484a0");
    doc
        .path("M30 78.6a1.6 1.6 0 0 1-.7-.2l-8.6-8.7a.9.9 0 0 1 1.2-1.2l8.7 8.6a.9.9 0 0 1 0 1.3.8.8 0 0 1-.6.2z")
        .fill("#fabc16");
    doc
        .path("M21.4 78.6a1.6 1.6 0 0 1-.7-.2.9.9 0 0 1 0-1.3l8.6-8.6a.9.9 0 0 1 1.3 1.2l-8.7 8.7a.8.8 0 0 1-.5.2z")
        .fill("#fabc16");
    doc
        .path("M50.2 72.4a1.6 1.6 0 0 1-.7-.2L41 63.4a.9.9 0 0 1 1.2-1.2l8.6 8.6a.9.9 0 0 1 0 1.2.7.7 0 0 1-.6.4z")
        .fill("#00a3d3");
    doc
        .path("M41.5 72.4a1.6 1.6 0 0 1-.6-.2.9.9 0 0 1 0-1.3l8.6-8.6a.9.9 0 1 1 1.2 1.2l-8.6 8.7a.8.8 0 0 1-.6.2z")
        .fill("#00a3d3");
    doc
        .path("M24.3 64.7a1 1 0 0 1-1-.9 13.3 13.3 0 0 1 13.4-13.2 12.8 12.8 0 0 1 8.6 3.2.9.9 0 1 1-1.1 1.3 11.7 " +
        "11.7 0 0 0-7.5-2.8A11.5 11.5 0 0 0 25 63.8a.9.9 0 0 1-.8 1z")
        .fill("#0484a0");
    doc
        .path("M40.2 56.9a1 1 0 0 1-.9-.8.9.9 0 0 1 .8-1l4.6-.7-.6-4.5a.9.9 0 0 1 1.7-.2l.8 5.4a1.4 1.4 0 0 1 0 " +
        ".7.6.6 0 0 1-.6.3l-5.7.7h-.1z")
        .fill("#0484a0");
    doc.restore();
    doc.fillColor(darkTeal);
    doc.moveTo(0, 9);
    doc.strokeColor("#0084A0");
    doc.font("Helvetica-Bold");
    doc.text("drinkcoach.org.uk", {
        align: "right"
    });
    doc.font("Helvetica");
    doc.text("MY IF/THEN PLAN", {
        align: "right"
    });
    doc.text(`Today's date: ${now.getDate()} ${getMonthName(now.getMonth())} ${now.getFullYear()}`, {
        align: "right"
    });
    doc.save();
    doc.fontSize(16);
    doc.font("Helvetica-Bold");
    doc.text("If x happens...", 0, 145, {
        width: 286,
        align: "right"
    });
    doc.fillColor(cyan);
    doc.moveUp();
    doc.text("...then my plan is x", 310, doc.y, {
        align: "left"
    });
    doc.moveDown();
    doc.fontSize(11);
    scenarios.forEach(({ scenario, action }) => {
        doc.fillColor(darkTeal);
        doc.moveDown();
        doc.moveDown();
        doc.text(scenario, 0, doc.y, {
            width: 286,
            indent: margin,
            align: "right"
        });
        doc.moveUp();
        doc.fillColor(cyan);
        doc.text(action, 310, doc.y, {
            align: "left"
        });
    });
    doc.font("Helvetica");
    doc.fillColor(darkTeal);
    doc.moveDown();
    doc.moveDown();
    doc.moveDown();
    doc.moveDown();
    doc.moveDown();
    const y = doc.y;
    doc.text("Use the space below to record any other scenarios:", 0, y, {
        width: 286,
        indent: margin,
        align: "right"
    });
    doc.fillColor(cyan);
    doc.text("Use the space below to record any other actions you will take:", 310, y, {
        align: "left"
    });
    doc.restore();
    // Footer text:
    doc.save();
    doc.fillColor(darkTeal);
    doc.fontSize(9);
    doc.font("Helvetica-Bold");
    doc.text("NHS GUIDELINES", margin, 712, {
        align: "left"
    });
    doc.font("Helvetica");
    doc.circle(margin + 0.75, doc.y + 5.75, 1.5).fill(darkTeal);
    doc.text("You are safest not regularly drinking more than 14 units per week – this applies to both men and " +
        "women. It is best to spread this evenly over three days or more.", 60, 725, {
        align: "left",
        width: 415,
        characterSpacing: -0.2,
        paragraphGap: 4
    });
    doc.circle(margin + 0.75, doc.y + 4.25, 1.5).fill(darkTeal);
    doc.text("If you are pregnant or planning a pregnancy, the safest approach is not to drink alcohol at all, " +
        "to keep risks to your baby to a minimum.", {
        width: 415,
        characterSpacing: -0.2,
        paragraphGap: 4
    });
    doc.circle(margin + 0.75, doc.y + 3.75, 1.5).fill(darkTeal);
    doc.text("If you wish to cut down the amount you’re drinking, a good way to achieve this is to have several" +
        "  ‘zero-alcohol’ days each week.", {
        width: 415,
        characterSpacing: -0.2,
        paragraphGap: 4
    });
    doc.restore();
    doc.save();
    doc.translate(486, 772);
    doc.scale(0.18);
    doc.rect(0, 0, 370.61, 150).fill("#005eb8");
    doc.scale(3.75);
    doc
        .path("m9.66 3.86h10.75l6.59 22.33h0.1l4.52-22.33h8.12l-6.83 32.2h-10.7l-6.74-22.28h-0.09l-4.47 22.28h-8.12z")
        .fill("#fff");
    doc
        .path("m42.91 3.86h8.63l-2.54 12.32h10.2l2.54-12.32h8.63l-6.69 32.2h-8.68l2.86-13.79h-10.15l-2.86 13.79h-8.62z")
        .fill("#fff");
    doc
        .path("m93.06 11.15a16.18 16.18 0 0 0-7.06-1.48c-3.41 0-6.18 0.51-6.18 3.09 0 4.57 12.5 2.86 12.5 12.64 " +
        "0 8.9-8.26 11.21-15.73 11.21a36 36 0 0 1-10-1.66l2-6.55c1.71 1.11 5.12 1.85 7.93 1.85s6.87-0.51 6.87-3.83c0-" +
        "5.17-12.5-3.23-12.5-12.32 0-8.3 7.29-10.8 14.35-10.8 4 0 7.7 0.42 9.87 1.43z")
        .fill("#fff");
    doc.restore();
    doc.end();
    return stream;
};
//# sourceMappingURL=create-pdf.js.map